/* Shared presentation; native Impact variants, cart and product identity remain authoritative. */
if (!customElements.get('smd-case-configurator')) {
  customElements.define('smd-case-configurator', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      this.formId = this.dataset.formId;
      const data = JSON.parse(this.querySelector('[data-case-variants]').textContent);
      this.variants = data.variants;
      this.money = data.money;
      this.nativeCombined=this.dataset.nativeCombined==='true';
      this.optionNames=data.options;
      this.caseIndex=this.optionNames.indexOf('Case Type');
      this.colorIndex=this.optionNames.indexOf('Color');
      if(this.dataset.previewThemeId){const previewURL=new URL(location.href);previewURL.searchParams.set('preview_theme_id',this.dataset.previewThemeId);history.replaceState({path:previewURL.toString()},'',previewURL);}
      if(this.nativeCombined)customElements.whenDefined('media-carousel').then(()=>{if(this.isConnected)this.update();});
      // Default to the first native size; explicit variant/device links remain authoritative.
      this.chosen = !!this.variant;
      this.pending = false;
      this.requested = null;
      this.failed = false;
      this.adding = false;
      this.addUncertain = false;
      this.moneyText = value => new DOMParser().parseFromString(String(value || ''),'text/html').body.textContent;
      this.normalize = value => String(value || '').toLowerCase().replace(/\s+/g, '');
      const deviceHint = new URL(location.href).searchParams.get('smd_device');
      const first = this.variants.find(v => String(v.id) === String(this.form?.querySelector('[name="id"]')?.value));
      if (deviceHint && (!first || this.normalize(first.option1) !== this.normalize(deviceHint))) {
        this.chosen = false;
        this.message(`${deviceHint} is not available for this case. Choose another device.`, true);
      }
      document.addEventListener('change', e => {
        if (!e.target.matches(`input[data-option-position][form="${this.formId}"]`)) return;
        if(this.nativeCombined){this.selectNative(e);return;}
        this.chosen = true;
        this.pending = true;
        this.failed = false;
        this.requested = this.selectedOptions();
        this.message('Updating your case…');
        clearTimeout(this.pendingTimer);
        this.pendingTimer=setTimeout(()=>{if(this.pending){this.failed=true;this.pending=false;this.message('Could not update your case. Choose your device again or reload the page.',true);this.update();}},12000);
        this.update();
      }, {capture:true,signal:this.abort.signal});
      this.addEventListener('variant:change', e => {
        if (e.target.getAttribute('id') !== this.formId) return;
        const v = e.detail.variant;
        if (this.requested && (!v || v.options.some((o,i) => o !== this.requested[i]))) {
          this.pending=false;this.failed=true;
          this.message('Choose your device again to confirm the latest selection.',true);this.update();return;
        }
        clearTimeout(this.pendingTimer);
        this.pending = false;
        this.failed = false;
        this.message('');
        this.update();
      }, {signal:this.abort.signal});
      this.addEventListener('submit', e => {
        if (e.target.getAttribute('id') !== this.formId) return;
        if (!this.canBuy()) { e.preventDefault();e.stopImmediatePropagation();this.edit();return; }
        this.adding = true;this.update();
        clearTimeout(this.addTimer);
        this.addTimer=setTimeout(()=>{if(this.adding){this.adding=false;this.addUncertain=true;this.message('We could not confirm your cart. Check your cart before trying again.',true);this.update();}},20000);
      }, {capture:true,signal:this.abort.signal});
      this.addEventListener('click', e => {
        const link = e.target.closest('[data-case-link]');
        if (link && this.pending) { e.preventDefault();return; }
        if (e.target.closest('[data-case-edit]')) this.edit();
        if (e.target.closest('[data-case-submit]')) {
          if (!this.canBuy()) {this.edit();return;}
          this.form.requestSubmit(this.form.querySelector('[type="submit"]'));
        }
      }, {signal:this.abort.signal});
      this.addEventListener('variant:add', e => {if(e.target.getAttribute('id')!==this.formId)return;clearTimeout(this.addTimer);this.adding=false;this.addUncertain=false;this.message('');this.update();}, {signal:this.abort.signal});
      this.addEventListener('cart:error', e => {if(e.target.getAttribute('id')!==this.formId)return;clearTimeout(this.addTimer);this.adding=false;this.addUncertain=false;this.update();}, {signal:this.abort.signal});
      this.observer = new MutationObserver(() => {
        if (this.pending && this.requested) {
          const native = this.querySelector('variant-picker');
          const v = native?.selectedVariant;
          if (v && v.options.every((o,i) => o === this.requested[i]) && String(this.form?.querySelector('[name="id"]')?.value) === String(v.id)) {
            this.pending=false;this.failed=false;this.message('');
          }
        }
        this.update();
      });
      this.observer.observe(this.querySelector('product-rerender'), {childList:true,subtree:true});
      this.watch = new IntersectionObserver(entries => {
        const above = entries[0].boundingClientRect.bottom < 0;
        this.querySelector('[data-case-sticky]').classList.toggle('is-visible', above);
      }, {threshold:0});
      const incoming = new URL(location.href).searchParams;
      if (this.nativeCombined && !incoming.has('variant') && !incoming.has('smd_device')) {
        const firstDevice = this.querySelector('input[data-option-position="1"]');
        if (firstDevice) { firstDevice.checked = true; this.selectNative({target:firstDevice}); }
      }
      this.update();
    }
    disconnectedCallback() {this.abort?.abort();this.observer?.disconnect();this.watch?.disconnect();clearTimeout(this.pendingTimer);clearTimeout(this.addTimer);}
    get form() {return document.getElementById(this.formId);}
    get variant() {return this.variants.find(v => String(v.id) === String(this.form?.querySelector('[name="id"]')?.value));}
    selectedOptions() {
      return [...document.querySelectorAll(`input[data-option-position][form="${this.formId}"]:checked`)]
        .sort((a,b)=>Number(a.dataset.optionPosition)-Number(b.dataset.optionPosition))
        .map(radio=>radio.dataset.optionName || radio.closest('label')?.textContent.trim() || document.querySelector(`label[for="${radio.getAttribute('id')}"]`)?.textContent.trim());
    }
    caseType(v=this.variant){return this.nativeCombined?(String(v?.options[this.caseIndex]).toLowerCase().includes('carbon')?'CARBON [S1]':'SLIM [S2]'):this.dataset.caseType;}
    updateSlimPreview(v){
      const frame=this.querySelector('[data-native-case-preview="SLIM"]');
      const image=frame?.querySelector('img');
      if(!image)return;
      const color=this.caseType(v)==='SLIM [S2]'?v.options[this.colorIndex]:(this.slimColor||'Black');
      const candidates=this.variants.filter(candidate=>String(candidate.options[this.caseIndex]).toUpperCase().includes('SLIM')&&candidate.options[this.colorIndex]===color);
      const preview=candidates.find(candidate=>candidate.available)||candidates[0];
      const source=preview?.featured_media?.preview_image?.src||preview?.featured_image?.src;
      frame.hidden=!source;
      if(!source)return;
      const url=new URL(source,location.origin);url.searchParams.set('width','180');
      if(image.getAttribute('src')!==url.toString()){
        image.removeAttribute('srcset');image.setAttribute('src',url.toString());
        image.setAttribute('sizes','60px');
      }
      image.alt=preview.featured_media?.alt||`SLIM case — ${color}`;
      frame.dataset.casePreviewVariant=preview.id;
      frame.dataset.casePreviewDevice=preview.option1;
      frame.dataset.casePreviewColor=color;
    }
    filterGallery(v){
      const gallery=this.querySelector('product-gallery');
      if(!gallery || !customElements.get('media-carousel') || !gallery._onVariantChanged)return;
      const group=this.caseType(v)==='CARBON [S1]'?'carbon':String(v.options[this.colorIndex]).toLowerCase();
      if(this.galleryGroup===group)return;
      const media=[...gallery.querySelectorAll('.product-gallery__media')];
      const classified=media.map(m=>{const alt=(m.querySelector('img')?.alt||'').toLowerCase();return alt.includes('carbon case')?'carbon':alt.match(/\b(black|gray|orange) slim case\b/)?.[1];});
      if(!classified.includes(group))return;
      const filteredIndexes=classified.map((g,i)=>g && g!==group?i:-1).filter(i=>i>=0);
      gallery.setAttribute('filtered-indexes',JSON.stringify(filteredIndexes.map(i=>i+1)));
      gallery.querySelectorAll('media-carousel').forEach(c=>c.dispatchEvent(new CustomEvent('carousel:filter',{detail:{filteredIndexes}})));
      gallery.querySelectorAll('page-dots').forEach(c=>c.dispatchEvent(new CustomEvent('control:filter',{detail:{filteredIndexes}})));
      if(v.featured_media)gallery._onVariantChanged({detail:{variant:v,previousVariant:null}});
      this.galleryGroup=group;
    }
    selectNative(e){
      const before=this.variant;
      if(Number(e.target.dataset.optionPosition)===1)this.chosen=true;
      let options=this.selectedOptions();
      const carbon=String(options[this.caseIndex]).toLowerCase().includes('carbon');
      const colorRadios=[...this.querySelectorAll(`input[data-option-position="${this.colorIndex+1}"]`)];
      if(carbon){if(this.caseType(before)==='SLIM [S2]')this.slimColor=before.options[this.colorIndex];const black=colorRadios.find(r=>r.dataset.optionName==='Black');if(black)black.checked=true;}
      else if(Number(e.target.dataset.optionPosition)===this.caseIndex+1 && this.slimColor){
        const candidate=options.slice();candidate[this.colorIndex]=this.slimColor;
        if(this.variants.some(v=>v.options.every((o,i)=>o===candidate[i]))){const color=colorRadios.find(r=>r.dataset.optionName===this.slimColor);if(color)color.checked=true;}
      }
      options=this.selectedOptions();
      const variant=this.variants.find(v=>v.options.every((o,i)=>o===options[i]));
      this.requested=options;this.pending=false;this.failed=!variant;
      if(!variant){this.message('This combination is unavailable. Choose another option.',true);this.update();return;}
      if(!carbon)this.slimColor=variant.options[this.colorIndex];
      this.form.querySelector('[name="id"]').value=variant.id;
      const script=this.querySelector('[data-native-picker] script[data-variant]');if(script)script.textContent=JSON.stringify(variant);
      const url=new URL(location.href);url.searchParams.set('variant',variant.id);history.replaceState({path:url.toString()},'',url);
      this.filterGallery(variant);
      this.form.dispatchEvent(new CustomEvent('variant:change',{bubbles:true,detail:{formId:this.formId,variant,previousVariant:before}}));
      this.message('');this.update();
    }
    canBuy() {const v=this.variant;return this.chosen && !this.pending && !this.failed && !this.adding && !this.addUncertain && v?.available && v.options.every((o,i)=>o===this.selectedOptions()[i]) && (!this.requested || v.options.every((o,i)=>o===this.requested[i]));}
    message(text,error=false) {
      const el=this.querySelector('[data-case-message]');
      if(el){if(el.textContent!==text)el.textContent=text;el.toggleAttribute('data-error',error);}
    }
    edit() {this.querySelector('.product-info__variant-picker').scrollIntoView({block:'center',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});this.querySelector('.variant-picker .select')?.focus({preventScroll:true});}
    update() {
      const watchEl=this.querySelector('.product-info__buy-buttons');
      if(watchEl && this.watched!==watchEl && this.watch){this.watch.disconnect();this.watched=watchEl;this.watch.observe(watchEl);}
      const v=this.variant;
      const ready=this.canBuy();
      const text=this.addUncertain?'Check your cart':this.adding?'Adding…':this.pending?'Updating…':!this.chosen||this.failed?'Choose your device':!v?'Unavailable':!v.available?'Sold out':'Add to cart';
      const native=this.form?.querySelector('[type="submit"]');
      if(native){native.disabled=!ready;const label=native.querySelector(':scope > div') || native.querySelector('.button__text');if(label && label.textContent!==text)label.textContent=text;}
      const sticky=this.querySelector('[data-case-submit]');
      sticky.disabled=!ready;if(sticky.textContent!==text)sticky.textContent=text;
      const summary=this.querySelector('[data-case-summary]');
      const caseType=this.caseType(v);
      const description=this.chosen && v ? (this.nativeCombined?v.option1+(caseType==='SLIM [S2]'?' · '+v.options[this.colorIndex]:''):v.title+(caseType==='SLIM [S2]' && v.options.length===1?' · Black':'')) : 'Choose your device';
      if(summary.textContent!==description)summary.textContent=description;
      const price=this.querySelector('[data-case-price]');
      if(v && price.textContent!==this.moneyText(this.money[v.id]))price.textContent=this.moneyText(this.money[v.id]);
      const checkCart=this.querySelector('[data-case-check-cart]');if(checkCart)checkCart.hidden=!this.addUncertain;
      const picker=this.querySelector('.variant-picker');
      const select=picker?.querySelector('.select span');
      if(!this.chosen && select && select.textContent!=='Choose your device')select.textContent='Choose your device';
      const deviceValue=picker?.querySelector('.variant-picker__option-info .h-stack > span');
      if(deviceValue)deviceValue.hidden=!this.chosen;
      const caseLabel=this.querySelector('[data-case-type-label]');if(caseLabel)caseLabel.textContent=caseType==='SLIM [S2]'?'SLIM':'CARBON';
      if(this.nativeCombined && v){
        this.querySelector('[data-option-field="Color"]').hidden=caseType==='CARBON [S1]';
        for(const field of this.querySelectorAll('[data-option-label-position]')){const index=Number(field.dataset.optionLabelPosition)-1;const value=index===this.caseIndex?(caseType==='SLIM [S2]'?'SLIM':'CARBON'):v.options[index];if(field.textContent!==value)field.textContent=value;}
        const select=picker.querySelector('.select span');const value=this.chosen?v.option1:'Choose your device';if(select && select.textContent!==value)select.textContent=value;
        for(const card of this.querySelectorAll('[data-native-case-card],[data-native-color]'))card.classList.toggle('is-selected',card.querySelector('input').checked);
        this.updateSlimPreview(v);
        for(const facts of this.querySelectorAll('[data-native-facts]'))facts.hidden=facts.dataset.nativeFacts!==caseType;
        this.filterGallery(v);
        const salePrice=this.querySelector('.product-info__price sale-price');const money=this.moneyText(this.money[v.id]);if(salePrice && salePrice.textContent!==money)salePrice.textContent=money;
      }
      for(const link of this.querySelectorAll('[data-case-link]')) {
        const data=JSON.parse(this.querySelector(`[data-case-product="${link.dataset.case}"]`).textContent);
        const url=new URL(data.url,location.origin);url.searchParams.set('view','combined-case');
        const currentURL=new URL(location.href);
        for(const [key,value] of currentURL.searchParams)if(key==='preview_theme_id'||key.startsWith('utm_')||key==='gclid'||key==='fbclid')url.searchParams.set(key,value);
        if(this.dataset.previewThemeId)url.searchParams.set('preview_theme_id',this.dataset.previewThemeId);
        if(this.chosen && v){
          const matches=data.variants.filter(candidate=>this.normalize(candidate.option1)===this.normalize(v.option1));
          const target=matches.find(candidate=>candidate.options.slice(1).join('|')===v.options.slice(1).join('|')) || matches.find(candidate=>candidate.option2==='Black') || matches[0];
          url.searchParams.set('smd_device',v.option1);
          if(target)url.searchParams.set('variant',target.id);
        }
        if(link.getAttribute('href')!==url.pathname+url.search)link.setAttribute('href',url.pathname+url.search);
        link.setAttribute('aria-disabled',String(this.pending));
      }
      this.dataset.ready='true';
    }
  });
}
